import { render, staticRenderFns } from "./Technology.vue?vue&type=template&id=5ed821bf&scoped=true&lang=html&"
import script from "./Technology.vue?vue&type=script&lang=js&"
export * from "./Technology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed821bf",
  null
  
)

export default component.exports